/* HavenCo — Global Wishlist V2
 *
 * One wishlist shared across:
 * - Best Sellers
 * - New Arrivals
 * - Collection pages
 * - Product pages
 * - Other HavenCo product sections
 *
 * Storage:
 *   havenco_wishlist_v2
 *
 * Legacy compatibility:
 *   havenco_wishlist_v1
 */

(function () {
  'use strict';

  if (window.__HavenCoGlobalWishlistV2) {
    return;
  }

  window.__HavenCoGlobalWishlistV2 = true;

  var STORAGE_KEY = 'havenco_wishlist_v2';
  var LEGACY_KEY = 'havenco_wishlist_v1';
  var COOKIE_KEY = 'havenco_wishlist_handles_v2';

  /*
   * All supported HavenCo wishlist buttons.
   */
  var SELECTOR = [
    '[data-hc-wishlist]',
    '[data-hc-na-wishlist]',
    '[data-wishlist]',
    '[data-havenco-wishlist]'
  ].join(',');


  /* ----------------------------------------
     SAFE STORAGE
  ---------------------------------------- */

  function safeParse(value, fallback) {
    try {
      var parsed = JSON.parse(value);

      if (parsed === null || parsed === undefined) {
        return fallback;
      }

      return parsed;
    } catch (error) {
      return fallback;
    }
  }


  function getLocal(key) {
    try {
      return safeParse(
        localStorage.getItem(key) || '[]',
        []
      );
    } catch (error) {
      return [];
    }
  }


  function setLocal(key, value) {
    try {
      localStorage.setItem(
        key,
        JSON.stringify(value)
      );
    } catch (error) {
      /* Ignore storage errors */
    }
  }


  /* ----------------------------------------
     COOKIE FALLBACK
  ---------------------------------------- */

  function getCookieHandles() {
    try {
      var match = document.cookie.match(
        /(?:^|;\s*)havenco_wishlist_handles_v2=([^;]*)/
      );

      if (!match) {
        return [];
      }

      var value = safeParse(
        decodeURIComponent(match[1]),
        []
      );

      return Array.isArray(value) ? value : [];

    } catch (error) {
      return [];
    }
  }


  function setCookieHandles(handles) {
    try {

      var clean = [];

      handles.forEach(function (handle) {

        if (!handle) {
          return;
        }

        if (clean.indexOf(handle) === -1) {
          clean.push(handle);
        }

      });

      var value = encodeURIComponent(
        JSON.stringify(clean)
      );

      document.cookie =
        COOKIE_KEY +
        '=' +
        value +
        ';path=/;max-age=31536000;SameSite=Lax';

    } catch (error) {
      /* Ignore cookie errors */
    }
  }


  /* ----------------------------------------
     PRODUCT HANDLE
  ---------------------------------------- */

  function getHandle(entry) {

    if (!entry) {
      return '';
    }

    if (typeof entry === 'string') {
      return entry;
    }

    return String(entry.handle || '');
  }


  /* ----------------------------------------
     NORMALIZE PRODUCT
  ---------------------------------------- */

  function normalizeEntry(entry) {

    if (!entry) {
      return null;
    }

    /*
     * Old code sometimes stored only a handle.
     */
    if (typeof entry === 'string') {

      /*
       * Ignore old numeric-only product IDs.
       */
      if (/^\d+$/.test(entry)) {
        return null;
      }

      return {
        handle: entry,
        title: '',
        url: '/products/' + encodeURIComponent(entry),
        image: '',
        price: null
      };
    }


    var handle = String(entry.handle || '');

    if (!handle) {
      return null;
    }


    return {
      id: entry.id || '',
      handle: handle,
      title: entry.title || '',
      url: entry.url ||
        ('/products/' + encodeURIComponent(handle)),
      image: entry.image || '',
      price:
        entry.price !== undefined
          ? entry.price
          : null
    };
  }


  /* ----------------------------------------
     READ WISHLIST
  ---------------------------------------- */

  function readWishlist() {

    var current = getLocal(STORAGE_KEY);

    if (!Array.isArray(current)) {
      current = [];
    }


    /*
     * Read old V1 wishlist too.
     *
     * This allows products saved by older
     * HavenCo code to remain available.
     */
    var legacy = getLocal(LEGACY_KEY);

    if (Array.isArray(legacy) && legacy.length) {

      current = current.concat(legacy);

    }


    /*
     * Cookie fallback.
     */
    var cookieHandles = getCookieHandles();

    cookieHandles.forEach(function (handle) {

      var exists = current.some(function (item) {

        return getHandle(item) === handle;

      });

      if (!exists) {

        current.push({

          handle: handle,
          title: '',
          url: '/products/' +
            encodeURIComponent(handle),
          image: '',
          price: null

        });

      }

    });


    /*
     * Normalize and remove duplicates.
     */
    var clean = [];
    var seen = {};

    current.forEach(function (entry) {

      var item = normalizeEntry(entry);

      if (!item || !item.handle) {
        return;
      }

      if (seen[item.handle]) {
        return;
      }

      seen[item.handle] = true;

      clean.push(item);

    });


    /*
     * Keep both storage systems synchronized.
     */
    setLocal(STORAGE_KEY, clean);
    setLocal(LEGACY_KEY, clean);

    setCookieHandles(
      clean.map(function (item) {
        return item.handle;
      })
    );


    return clean;
  }


  /* ----------------------------------------
     WRITE WISHLIST
  ---------------------------------------- */

  function writeWishlist(items) {

    var clean = [];
    var seen = {};

    items.forEach(function (entry) {

      var item = normalizeEntry(entry);

      if (!item || !item.handle) {
        return;
      }

      if (seen[item.handle]) {
        return;
      }

      seen[item.handle] = true;

      clean.push(item);

    });


    setLocal(STORAGE_KEY, clean);

    /*
     * Legacy compatibility.
     */
    setLocal(LEGACY_KEY, clean);


    /*
     * Cookie fallback.
     */
    setCookieHandles(
      clean.map(function (item) {
        return item.handle;
      })
    );


    /*
     * Tell every HavenCo component
     * that the wishlist changed.
     */
    try {

      window.dispatchEvent(
        new CustomEvent(
          'havenco:wishlist:changed',
          {
            detail: {
              items: clean
            }
          }
        )
      );

    } catch (error) {
      /* Ignore event errors */
    }


    return clean;
  }


  /* ----------------------------------------
     PRODUCT DATA FROM BUTTON
  ---------------------------------------- */

  function productFromButton(button) {

    return normalizeEntry({

      id:
        button.dataset.productId ||
        button.dataset.id ||
        '',

      handle:
        button.dataset.productHandle ||
        button.dataset.handle ||
        '',

      title:
        button.dataset.productTitle ||
        button.dataset.title ||
        '',

      url:
        button.dataset.productUrl ||
        button.dataset.url ||
        '',

      image:
        button.dataset.productImage ||
        button.dataset.image ||
        '',

      price:
        button.dataset.productPrice ||
        button.dataset.price ||
        null

    });
  }


  /* ----------------------------------------
     CHECK SAVED STATE
  ---------------------------------------- */

  function isSaved(handle) {

    if (!handle) {
      return false;
    }

    var items = readWishlist();

    return items.some(function (item) {

      return getHandle(item) === handle;

    });
  }


  /* ----------------------------------------
     UPDATE BUTTON VISUAL STATE
  ---------------------------------------- */

  function updateButton(button) {

    var item = productFromButton(button);

    if (!item || !item.handle) {
      return;
    }


    var saved = isSaved(item.handle);


    /*
     * Main saved state.
     */
    button.classList.toggle(
      'is-saved',
      saved
    );


    /*
     * Accessibility.
     */
    button.setAttribute(
      'aria-pressed',
      saved ? 'true' : 'false'
    );


    button.setAttribute(
      'data-wishlist-state',
      saved ? 'saved' : 'not-saved'
    );


    /*
     * Accessible label.
     */
    var title = item.title || 'product';

    button.setAttribute(
      'aria-label',
      saved
        ? 'Remove ' + title + ' from wishlist'
        : 'Add ' + title + ' to wishlist'
    );


    /*
     * Common label elements.
     */
    var label =
      button.querySelector(
        '[data-wishlist-label]'
      );

    if (label) {

      label.textContent =
        saved
          ? 'Saved to wishlist'
          : 'Add to wishlist';

    }


    /*
     * SVG heart state.
     *
     * We support both stroke-only
     * and fill-based heart SVGs.
     */
    var svg =
      button.querySelector('svg');

    if (svg) {

      svg.classList.toggle(
        'is-saved',
        saved
      );

    }


    /*
     * Some HavenCo versions use
     * data attributes for the icon.
     */
    var icon =
      button.querySelector(
        '[data-wishlist-icon]'
      );

    if (icon) {

      icon.classList.toggle(
        'is-saved',
        saved
      );

    }

  }


  /* ----------------------------------------
     UPDATE ALL BUTTONS
  ---------------------------------------- */

  function syncAllButtons() {

    var buttons =
      document.querySelectorAll(
        SELECTOR
      );

    buttons.forEach(function (button) {

      updateButton(button);

    });

  }


  /* ----------------------------------------
     ADD / REMOVE
  ---------------------------------------- */

  function toggleWishlist(button) {

    var item =
      productFromButton(button);

    if (!item || !item.handle) {

      return;

    }


    var items =
      readWishlist();


    var index =
      items.findIndex(function (entry) {

        return getHandle(entry) === item.handle;

      });


    var adding =
      index === -1;


    if (adding) {

      items.push(item);

    } else {

      items.splice(index, 1);

    }


    /*
     * Save the new global wishlist.
     */
    writeWishlist(items);


    /*
     * Immediately update every
     * matching heart on the page.
     */
    syncAllButtons();


    /*
     * Animation.
     */
    button.classList.remove(
      'is-animating'
    );

    void button.offsetWidth;

    button.classList.add(
      'is-animating'
    );


    /*
     * Custom event for any other
     * HavenCo component.
     */
    try {

      window.dispatchEvent(
        new CustomEvent(
          'havenco:wishlist:toggled',
          {
            detail: {
              product: item,
              saved: adding
            }
          }
        )
      );

    } catch (error) {
      /* Ignore event errors */
    }

  }


  /* ----------------------------------------
     ONE GLOBAL CLICK HANDLER
  ---------------------------------------- */

  document.addEventListener(
    'click',
    function (event) {

      var button =
        event.target.closest(
          SELECTOR
        );


      if (!button) {
        return;
      }


      /*
       * IMPORTANT:
       *
       * Prevent old section-specific
       * wishlist handlers from firing.
       */
      event.preventDefault();

      event.stopPropagation();

      if (event.stopImmediatePropagation) {
        event.stopImmediatePropagation();
      }


      toggleWishlist(button);

    },
    true
  );


  /* ----------------------------------------
     STORAGE CHANGE
  ---------------------------------------- */

  window.addEventListener(
    'storage',
    function (event) {

      if (
        event.key === STORAGE_KEY ||
        event.key === LEGACY_KEY
      ) {

        syncAllButtons();

      }

    }
  );


  /* ----------------------------------------
     HAVENCO WISHLIST EVENT
  ---------------------------------------- */

  window.addEventListener(
    'havenco:wishlist:changed',
    function () {

      syncAllButtons();

    }
  );


  /* ----------------------------------------
     OBSERVE DYNAMICALLY ADDED PRODUCTS
  ---------------------------------------- */

  var observer =
    new MutationObserver(
      function () {

        syncAllButtons();

      }
    );


  function startObserver() {

    if (!document.body) {
      return;
    }

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );

  }


  /* ----------------------------------------
     INITIALIZE
  ---------------------------------------- */

  function initialize() {

    /*
     * Read and normalize existing
     * wishlist data.
     */
    readWishlist();

    /*
     * Update all visible hearts.
     */
    syncAllButtons();

    /*
     * Watch Shopify dynamic rendering.
     */
    startObserver();

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );

  } else {

    initialize();

  }


})();